export default __webpack_public_path__ + "static/media/Visa.7aaf5829.svg";